'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _components2 = require('components');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// We use this to handle datetime values (but only show values for the user to edit)
// (specifically used for POSTing flight_statuses which need us to use datetime values,
//  but only requires the user to specify a date)
var DatetimeDateInput = function DatetimeDateInput(_ref) {
    var input = _ref.input,
        props = (0, _objectWithoutProperties3.default)(_ref, ['input']);
    return _react2.default.createElement(_components2.Input, (0, _extends3.default)({ input: (0, _extends3.default)({}, input, { value: input.value.split('T')[0] }) }, props, { type: 'date' }));
};
DatetimeDateInput.propTypes = {
    input: _propTypes2.default.shape({
        value: _propTypes2.default.string.isRequired
    })
};

exports.default = DatetimeDateInput;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./app/components/forms/DatetimeDateInput.js
// module id = 1340
// module chunks = 0